import { Typography } from '@mui/material';

interface VersionInfoProps {
  variant?: 'default' | 'compact';
}

/**
 * Displays the application version.
 * Uses the VITE_APP_VERSION environment variable injected at build time by vite.config.ts
 */
export function VersionInfo({ variant = 'default' }: VersionInfoProps) {
  const version = import.meta.env.VITE_APP_VERSION || 'unknown';

  if (variant === 'compact') {
    return (
      <Typography variant="caption" color="text.secondary">
        v{version}
      </Typography>
    );
  }

  return (
    <Typography variant="body2" color="text.secondary">
      Version: {version}
    </Typography>
  );
}
